import { render } from "./Wisdom.vue?vue&type=template&id=226ef41e"
import script from "./Wisdom.vue?vue&type=script&lang=js"
export * from "./Wisdom.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__